/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./star.vue?vue&type=template&id=3307db28&scoped=true&"
import script from "./star.vue?vue&type=script&setup=true&lang=js&"
export * from "./star.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./star.vue?vue&type=style&index=0&id=3307db28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3307db28",
  null
  
)

export default component.exports